import logo from './logo.svg';
import React from "react";
import './App.css';
import mapStyles from "./mapStyle";
import * as asianCommunitiesData from "./asianCommunities.json";
import * as asianHateCrime from "./asianHateCrime.json";
//import "@reach/combobox/style.css";
import { formatRelative } from 'date-fns';
import {
  GoogleMap,
  useLoadScript,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";
import {
  Combobox,
  ComboboxInput,
  ComboboxPopover,
  ComboboxList,
  ComboboxOption,
} from "@reach/combobox";
import "@reach/combobox/styles.css";
const libraries = ["places"];

const mapContainerStyle = {
  width: "100vw",
  height: "100vh",

};
const center = {
  lat: 43.653225,
  lng: -79.383186,
};
const removeUI = {
  styles: mapStyles,
  disableDefaultUI: true,
  zoomControl: true,
};
export default function App() {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY,
    libraries,
  });
  const [markers, setMarkers] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [selectedCommunities, setSelectedCommunities] = React.useState(null);
  const [selectedCrime, setSelectedCrime] = React.useState(null);
  const onMapClick = React.useCallback((event) => {
    setMarkers((current) => [...current, {
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
      time: new Date(),
    },
    ]);
  }, []);

  const mapRef = React.useRef();
  const onMapLoad = React.useCallback((map) => {
    mapRef.current = map;
  }, []);

  const panTo = React.useCallback(({ lat, lng }) => {
    mapRef.current.panTo({ lat, lng });
    mapRef.current.setZoom(20);
  }, []);

  if (loadError) return "Error loading maps";
  if (!isLoaded) return "Loading maps";
  return (
    <div className="App">
      {/* <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header> */}
     

      <Search panTo={panTo} />
      

      <GoogleMap
        mapContainerStyle={mapContainerStyle}

        zoom={8}
        center={center}
        removeUI={removeUI}
        onClick={onMapClick}
        onLoad={onMapLoad}
      //  mapId={"a4461d5f924d51e1"}
      >


        {asianCommunitiesData.features.map(community => (
          <Marker
            key={community.properties.COMMUNITY_ID}
            position={{
              lat: community.geometry.coordinates[1],
              lng: community.geometry.coordinates[0],
            }}
            onClick={() => {
              setSelectedCommunities(community);
            }}
            icon={{
              url: "/community.png",
              scaledSize: new window.google.maps.Size(50, 50),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
            }} />
        ))}

        {selectedCommunities ? (
          <InfoWindow
            onCloseClick={() => {
              setSelectedCommunities(null);
            }}
            position={{
              lat: selectedCommunities.geometry.coordinates[1],
              lng: selectedCommunities.geometry.coordinates[0],
            }}
          >
            <div>
              <h2>{selectedCommunities.properties.NAME}</h2>
              <p>{selectedCommunities.properties.DESCRIPTION}</p>
              <p>{selectedCommunities.properties.ADDRESS}</p>
              <a href={selectedCommunities.properties.WEBSITE} target="_blank">Website: {selectedCommunities.properties.WEBSITE}</a>
              <p> <a href="tel:{selectedCommunities.properties.TELEPHONE}">Telephone: {selectedCommunities.properties.TELEPHONE}</a></p>

            </div>
          </InfoWindow>
        ) : null}

        {asianHateCrime.features.map(crime => (
          <Marker
            key={crime.properties.CRIME_ID}
            position={{
              lat: crime.geometry.coordinates[1],
              lng: crime.geometry.coordinates[0],
            }}
            onClick={() => {
              setSelectedCrime(crime);
            }}
            icon={{
              url: "/crimeScene.png",
              scaledSize: new window.google.maps.Size(50, 50),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
            }} />
        ))}

        {selectedCrime ? (
          <InfoWindow
            onCloseClick={() => {
              setSelectedCrime(null);
            }}
            position={{
              lat: selectedCrime.geometry.coordinates[1],
              lng: selectedCrime.geometry.coordinates[0],
            }}
          >
            <div>
              <table>
                <tr>
                  <td><b>Date of incident</b></td>
                  <td>{selectedCrime.properties.DATE_OF_INCIDENT}</td>
                </tr>
                <tr>
                  <td><b>Place of incident</b></td>
                  <td>{selectedCrime.properties.PLACE_OF_INCIDENT}</td>
                </tr>
                <tr>
                  <td><b>Summary</b></td>
                  <td>{selectedCrime.properties.SUMMARY}</td>
                </tr>
                <tr>
                  <td><b>Types of incident</b></td>
                  <td>{selectedCrime.properties.TYPES_OF_INCIDENT}</td>
                </tr>
                <tr>
                  <td><b>News Source</b></td>
                  <td> <a href={selectedCrime.properties.NEWS_SOURCE} target="_blank">Details</a></td>
                </tr>
                <tr>
                  <td><b>Latitude</b></td>
                  <td>{selectedCrime.properties.LATITUDE}</td>
                </tr>
                <tr>
                  <td><b>Longtitude</b></td>
                  <td>{selectedCrime.properties.LONGTITUDE}</td>
                </tr>
              </table>
            </div>
          </InfoWindow>
        ) : null}

        {markers.map((marker) => (
          <Marker key={marker.time.toISOString()}
            position={{ lat: marker.lat, lng: marker.lng }}
            icon={{
              url: "/crimeScene.png",
              scaledSize: new window.google.maps.Size(50, 50),
              origin: new window.google.maps.Point(0, 0),
              anchor: new window.google.maps.Point(15, 15),
            }}
            onClick={() => {
              setSelected(marker);
            }} />
        ))}

        {selected ? (
          <InfoWindow
            position={{ lat: selected.lat, lng: selected.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div>
              <h2>Hate Crime occured! </h2>
              <p>Hate Crime happened at {formatRelative(selected.time, new Date())}</p>
            </div>
          </InfoWindow>
        ) : null}

      </GoogleMap>
    </div>

  );
}
// function Locate({ panTo }) {
//   return (
//     <button
//       className="locate"
//       onClick={() => {
//         navigator.geolocation.getCurrentPosition(
//           (position) => {
//             try {
//               panTo({
//                 lat: position.coords.latitude,
//                 lng: position.coords.longtitude,
//               });
//             } catch (eror) {
//               console.log("Error");
//             }

//             // const pos = {
//             //   lat: position.coords.latitude,
//             //    lng: position.coords.longtitude,
//             // };

//           },
//           () => null
//         );
//       }}
//     >
//       <img src="gps.png" alt="Find your current location" style={{ width: '20%', height: '20%' }} />
//     </button>
//   );
// }


function Search({ panTo }) {
  const { ready, value, suggestions: { status, data }, setValue, clearSuggestion } = usePlacesAutocomplete({
    requestOptions: {
      location: { lat: () => 43.653225, lng: () => -79.383186 },
      radius: 200 * 1000,
    },
  });

  return (
    <div className="search">
      <Combobox onSelect={async (address) => {
        setValue(address, false);
        //   clearSuggestions();

        try {
          const results = await getGeocode({ address });
          const { lat, lng } = await getLatLng(results[0]);
          panTo({ lat, lng });
        } catch (error) {
          console.log("Error!");
        }

      }}>
        <ComboboxInput value={value} onChange={(e) => {
          setValue(e.target.value);
        }}
          disabled={!ready}
          placeholder="Enter an address"
        />
        <ComboboxPopover>
          <ComboboxList>
            {status === "OK" && data.map(({ id, description }) => (<ComboboxOption key={id} value={description} />
            ))}
          </ComboboxList>
        </ComboboxPopover>
      </Combobox>
    </div>
  );
}

